<template>
    <v-container fluid id="heading" style="border-bottom: solid 1px #dcdcdc;" class="fill-height">
        <v-row>
            <v-col v-if="showLogo"
                   class="d-flex"
                   style="max-height: 100%;"
                   v-bind:class="{'justify-center col-12': currentStep === 0, 'justify-start col-xs-8 col-sm-3 col-md-3 col-lg-3 col-xl-3': currentStep !== 0  && isWalkin, 'pl-8': currentStep !== 0}">
                <v-img v-if="currentModel"
                       :src="logoApiUrl"
                       :alt="currentModel.settings.clientName"
                       :max-width="logoMaxWidth"
                       max-height="100%"
                       contain>
                </v-img>
                <v-skeleton-loader v-else type="image" max-height="250" max-width="350" min-width="250"></v-skeleton-loader>
            </v-col>
            <v-col v-if="showFacilityName"
                   class="d-sm-flex d-xs-flex d-md-flex d-lg-flex justify-center col-6"
                   v-bind:class="facilityNameClasses"
                   style="flex-direction: column;">
                <strong class="client-name">{{ currentModel.settings.clientName }}</strong>
                <p v-if="showPtt" class="ptt">
                    <span>{{ currentModel.settings.localizedContent['treatment_time_caption'] }} </span>
                    <strong>{{ displayTime }}</strong>
                </p>
            </v-col>
            <v-col v-if="showInfo"
                   class="pr-8 d-flex justify-end col-xs-4 col-md-3 col-sm-3 col-lg-3 col-xl-3">
                <v-btn small fab dark color="primary" @click="$store.state.showInstructions = true" class="elevation-3">
                    <v-icon dark>mdi-help</v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ContextualMixin from '../mixins/contextualMixin.js'
    /*eslint-disable no-debugger*/
    export default {
        name: 'Heading',
        mixins: [ContextualMixin],
        computed: {
            showLogo() {
                return this.currentStep === 0 || this.$vuetify.breakpoint.smAndUp || this.isOnline;
            },
            showFacilityName() {
                return this.currentStep !== 0 && this.currentModel && this.isWalkin;
            },
            showInfo() {
                return this.currentStep !== 0 && this.currentModel && (this.isWalkin || this.isOnline);
            },
            logoMaxWidth() {
                if (this.$vuetify.breakpoint.xs)
                    return this.currentStep == 0 ? '190px' : '170px';
                if (this.$vuetify.breakpoint.sm)
                    return this.currentStep == 0 ? '200px' : '180px';
                if (this.$vuetify.breakpoint.mdAndUp)
                    return this.currentStep == 0 ? '220px' : '190px';
                return '190px';
            },
            facilityNameClasses() {
                if (this.$vuetify.breakpoint.xs)
                    return 'pl-8 self-center';
                return '';
            },
            displayTime() {
                let t = this.currentModel.availableTime.actualAvailableTimeDisplay;
                return t.replace(t.substring(t.length - 5, t.length), '').trim();
            },
            logoApiUrl() {
                // Example: azureAssetsPath = "assets-dev/images/client-logos"
                //          logoFileName   = "acme.png"
                // Result:  "assets-dev/images/client-logos/acme.png"
                //const path =
                //    `${this.currentModel.settings.azureAssetsPath}`.replace(/\/+$/, '') +
                //    '/' +
                //    `${this.currentModel.settings.logoFileName}`.replace(/^\/+/, '');
                //const path =
                //    `${this.currentModel.settings.logoFileName}`.replace(/^\/+/, '');

                return `/api/Walkin/file_blob?fileName=/${this.currentModel.settings.logoFileName}`;
            }
        },
        methods: {
            onLogoError(e) {
                // optional fallback
                e.target.src = '/images/logo-fallback.svg';
            }
        }
    }
</script>

<style scoped>
    #heading { background: white; }
    #heading .col { align-items: center; }
    .ptt { margin-bottom: 0!important; }
    .self-center { align-self: center; }
    @media (min-width: 900px) {
        .client-name {
            /*margin-top: 15px;*/
            font-size: 20px;
        }
        .ptt { font-size: 16px;}
    }
    @media (max-width: 600px) { 
        .ptt, .client-name { white-space: nowrap; }
    }
</style>